/**
 * 네이티브 Apple 로그인 서비스
 * React Native WebView 브릿지를 통해 네이티브 Sign in with Apple 호출
 */

export interface NativeAppleAuthResult {
  identityToken: string
  email?: string
  name?: string
}

class NativeAppleAuthService {
  private isInitialized = false

  /**
   * React Native WebView 브릿지 사용 가능 여부 확인
   */
  private isBridgeAvailable(): boolean {
    return typeof window !== 'undefined' &&
           (window.ReactNativeWebView !== undefined ||
            (window as any).webkit?.messageHandlers?.appleLogin !== undefined ||
            (window as any).Android?.appleLogin !== undefined)
  }

  /**
   * 초기화 (필요시)
   */
  async initialize(): Promise<void> {
    if (this.isInitialized) return

    if (!this.isBridgeAvailable()) {
      throw new Error('네이티브 Apple 로그인을 사용할 수 없습니다. 앱에서 실행해주세요.')
    }

    this.isInitialized = true
  }

  /**
   * Apple 로그인 실행
   */
  async signIn(): Promise<NativeAppleAuthResult> {
    await this.initialize()

    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        if ((window as any).appleLoginCallback) {
          delete (window as any).appleLoginCallback
        }
        reject(new Error('Apple 로그인 시간이 초과되었습니다. 다시 시도해주세요.'))
      }, 60000)

      ;(window as any).appleLoginCallback = (result: NativeAppleAuthResult | null, error: string | null) => {
        clearTimeout(timeout)
        delete (window as any).appleLoginCallback

        if (error) {
          reject(new Error(error))
        } else if (result && result.identityToken) {
          resolve(result)
        } else {
          reject(new Error('Apple 로그인에서 identityToken을 받지 못했습니다.'))
        }
      }

      if (window.ReactNativeWebView) {
        const message = JSON.stringify({
          type: 'APPLE_LOGIN',
        })
        window.ReactNativeWebView.postMessage(message)
      } else if (
        (window as any).webkit &&
        (window as any).webkit.messageHandlers &&
        (window as any).webkit.messageHandlers.appleLogin
      ) {
        ;(window as any).webkit.messageHandlers.appleLogin.postMessage({})
      } else if ((window as any).Android && typeof (window as any).Android.appleLogin === 'function') {
        ;(window as any).Android.appleLogin()
      } else {
        clearTimeout(timeout)
        delete (window as any).appleLoginCallback
        reject(new Error('Apple 로그인 브릿지를 사용할 수 없습니다. 앱에서 실행해주세요.'))
      }
    })
  }
}

export const nativeAppleAuthService = new NativeAppleAuthService()
